<template>
<div class="collapsible-body">
    <div class="row" style="padding-bottom: 25px;">
        <template v-if="items.length > 0">
            <div class="col s2 leftlabel">{{$t('documents.date_of_issue')}}</div>
            <div class="col s3 leftlabel">{{$t('documents.name')}}</div>
            <div class="col s3 leftlabel">{{$t('documents.description')}}</div>
            <div class="col s2 leftlabel">{{$t('documents.document_type')}}</div>
        </template>
    </div>
    <div class="row" v-for="(doc, index) in items" v-show="!doc._destroy" v-if="doc.url">
         <div class="col s2 input-field">
            <input type="date" class="datepicker" v-model="doc.created_at" :disabled="true">
        </div>
        <div class="col s3 input-field">
            <input v-model="doc.name" :disabled="editdocuments == false" :placeholder="$t('settings.documents.name_placeholder')" />
        </div>
        <div class="col s3  input-field">
            <input v-model="doc.description" :disabled="editdocuments == false" :placeholder="$t('settings.documents.description_placeholder')" />
        </div>
        <div class="col s2 selectorignored">
            <select v-model="doc.type" :disabled="editdocuments == false || doc.id">
                <option value="insurance">{{$t('settings.documents.types.insurance')}}</option>
                <option value="certificate">{{$t('settings.documents.types.certificate')}}</option>
                <option value="reference">{{$t('settings.documents.types.references')}}</option>
                <option value="other_document">{{$t('settings.documents.types.other')}}</option>
            </select>
        </div>
        <div class="col s1" :class="{'docselector': (doc.file == undefined && doc.url == undefined)}" style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
            <label :for="'docs'+index" v-if="!doc.url">{{doc.file == undefined ? "Wybierz plik..." : doc.file.name}}</label>
            <input type="file" :id="'docs'+index" @change="setFile(doc, $event.target.name, $event.target.files)" v-if="!doc.url" hidden />
            <a :href="doc.url" v-if="doc.url">
                <i class="material-icons">insert_drive_file</i>
            </a>
        </div>
       </div>
        <div v-if="load" class="preloader-wrapper small active">
            <div class="spinner-layer spinner-red-only">
                <div class="circle-clipper left">
                    <div class="circle"></div>
                </div>
                <div class="gap-patch">
                    <div class="circle"></div>
                </div>
                <div class="circle-clipper right">
                    <div class="circle"></div>
                </div>
            </div>
        </div>
    </div>

</template>
<script>
import axios from 'axios';
import _ from 'lodash';
import moment from 'moment';
export default {
  data: function () {
    return {
      items: [],
      editdocuments: false,
      load: true
    }
  },
  mounted: async function(){
    var response = await axios.get("/documents.json");
    var docs = []
    for (var insurance of response.data.insurances) {
        docs.push({
            id: insurance.id,
            type: "insurance",
            created_at: moment(insurance.created_at).format(moment.HTML5_FMT.DATE),
            name: insurance.policy_no,
            url: insurance.url,
            description: (_.isNil(insurance.description) && moment(insurance.date).isValid() ? moment(insurance.date).format("DD.MM.YYYY") : insurance.description),
            date: insurance.valid_until
        })
    }
    for (var reference of response.data.references) {
        docs.push({
            id: reference.id,
            created_at: moment(reference.created_at).format(moment.HTML5_FMT.DATE),
            type: "reference",
            url: reference.url,
            date: reference.date,
            description: reference.description,
            name: reference.name
        })
    }
    for (var certificate of response.data.certificates) {
        docs.push({
            id: certificate.id,
            type: "certificate",
            created_at: moment(certificate.created_at).format(moment.HTML5_FMT.DATE),
            url: certificate.url,
            date: certificate.date,
            description: (_.isNil(certificate.description) && moment(certificate.date).isValid() ? moment(certificate.date).format("DD.MM.YYYY") : certificate.description),
            name: certificate.name
        })
    }
    for (var other_document of response.data.other_documents) {
        docs.push({
            id: other_document.id,
            type: "other_document",
            url: other_document.url,
            created_at: moment(other_document.created_at).format(moment.HTML5_FMT.DATE),
            date: other_document.date,
            description: (_.isNil(other_document.description) && moment(other_document.date).isValid() ? moment(other_document.date).format("DD.MM.YYYY") : other_document.description),
            name: other_document.name
        })
    }
    for (var other_document of response.data.documents) {
          docs.push({
              id: other_document.id,
              type: other_document.doctype,
              url: other_document.url,
              created_at: moment(other_document.created_at).format(moment.HTML5_FMT.DATE),
              date: other_document.date,
              description: (_.isNil(other_document.description) && moment(other_document.date).isValid() ? moment(other_document.date).format("DD.MM.YYYY") : other_document.description),
              name: other_document.name
          })
    }
    this.items = docs;
    this.load = false;
  },
methods: {

},
  computed: {
   
  },
  
}
</script>
<style scoped>
div {
  margin-left: auto;
  left: auto;
  right: auto;
  line-height: 2;
}
select{
  display: block !important;
}
</style>